module.exports = __webpack_public_path__ + "img/SOV Report.66ba4b68.svg";